module.exports = __webpack_public_path__ + "img/green-wallet.146fcb0c.svg";